(() => {
let savedScrollY = 0;

const preventScroll = (e) => {
  // Check if the touch target is inside a scrollable element
  let el = e.target;
  while (el && el !== document.body) {
    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    const overflowX = style.overflowX;
    const isScrollableY = (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
    const isScrollableX = (overflowX === 'auto' || overflowX === 'scroll') && el.scrollWidth > el.clientWidth;
    
    if (isScrollableY || isScrollableX) {
      return; // Allow scroll inside scrollable elements
    }
    el = el.parentElement;
  }
  e.preventDefault(); // Block scroll on non-scrollable elements
};

const disableBodyScroll = () => {
  savedScrollY = window.scrollY;
  document.documentElement.style.overflow = 'hidden';
  document.documentElement.style.height = '100%';
  document.body.style.overflow = 'hidden';
  document.body.style.height = '100%';
  // Prevent touchmove on body but allow it inside the modal
  document.body.addEventListener('touchmove', preventScroll, { passive: false });
};

const enableBodyScroll = () => {
  document.documentElement.style.overflow = '';
  document.documentElement.style.height = '';
  document.body.style.overflow = '';
  document.body.style.height = '';
  document.body.removeEventListener('touchmove', preventScroll);
  window.scrollTo(0, savedScrollY);
};

// Fix for iOS Safari not clearing overflow on close
/* document.addEventListener('click', (e) => {
  if (e.target.hasAttribute('data-micromodal-close') || 
      e.target.closest('[data-micromodal-close]')) {
    enableBodyScroll();
  }
}); */

document.querySelectorAll('.modal__container').forEach(modal => {
  modal.addEventListener('touchmove', (e) => {
    e.stopPropagation();
  }, { passive: true });
});

// Add to each modal element
document.querySelectorAll('.modal__container').forEach(modal => {
  modal.addEventListener('touchmove', allowModalScroll);
});

  document.addEventListener('alpine:init', () => {
    MicroModal.init({ disableScroll: false });

  // Allow scroll inside modals
  document.querySelectorAll('.modal__container').forEach(modal => {
    modal.addEventListener('touchmove', (e) => {
      e.stopPropagation();
    }, { passive: false });
  });
    // Linked Products variant switching
    Alpine.data('LinkedProducts', (type) => ({
      linkedProductsType: '',
      $section: null,
      $products: [],
      products: [],
      hasSpecs: false,
      init() {
        let am = this;
        am.linkedProductsType = type;

        document.addEventListener('init-LinkedProducts', (e) => {
          if (am.$section) return;

          am.$section = e.target;
          am.$products = [...am.$section.querySelectorAll('[data-linked-product]')];

          // init products on page load
          (async () => {
            let px_products = am.$products.map(($item) => {
              let handle = $item.dataset.linkedProduct;
              return fetch(`/products/${handle}.js`).then(res => res.json());
            });

            am.products = await Promise.all(px_products);
            am.UpdateLinkedProductUrls();
          })();
        });
        subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          am.UpdateLinkedProductUrls(e.data.variant.options);
        });
      },

      UpdateLinkedProductUrls(current_values) {
        let am = this;

        if (!am.products.length) return;

        am.$products.forEach(($product) => {
          let handle = $product.dataset.linkedProduct;
          let product = am.products.find(p => p.handle == handle);

          if (!product) return;

          if (!current_values) {
            current_values = JSON.parse($product.dataset.current_values);
          }

          let optionIdsToMatch = [1, 2, 3];
          if (am.linkedProductsType) {
            // exclude option from matching
            optionIdsToMatch = optionIdsToMatch.filter((id) => product.options.map(opt => opt.name).indexOf(am.linkedProductsType) !== (id - 1));
            //console.log(optionIdsToMatch);
          }

          let valuesToMatch = optionIdsToMatch.map((id) => current_values[(id - 1)]);

          let matching_variant = product.variants.find((v) => {
            let v_options = optionIdsToMatch.map((id) => v[`option${id}`]).join('/');
            return v_options == valuesToMatch.join('/')
          });
          if (!matching_variant) return;
          $product.setAttribute('href', `/products/${handle}?variant=${matching_variant.id}`);

          // apply soldout class if not available
          // requested to not gray them out
          /* const shapeLabel = $product.querySelector('label')
          if (shapeLabel) {
            shapeLabel.classList.toggle('disabled', !(matching_variant && matching_variant.available));
          } */
        });
      }
    }));


    Alpine.data('CheckCompatibility', () => ({
      e_OpenCheckCompatibilityModal() {

        MicroModal.show('check-compatibility', {
  disableScroll: false,
  awaitCloseAnimation: false,
          onShow: () => disableBodyScroll(),
          onClose: () => enableBodyScroll()
        });

      }
    }))
    Alpine.data('LensFeatureChart', () => ({
      e_OpenLensFeatureChartModal() {

        MicroModal.show('lens-feature-chart', {
  disableScroll: false,
  awaitCloseAnimation: false,
          onShow: () => disableBodyScroll(),
          onClose: () => enableBodyScroll()
        });

      }
    }))
    Alpine.data('ColorQuiz', () => ({
      e_OpenColorQuizModal() {
        MicroModal.show('color-quiz-modal', {
  disableScroll: false,
  awaitCloseAnimation: false,
          onShow: () => {
            disableBodyScroll();
            setTimeout(() => {
              const alpine = document.querySelector('[x-data="cqData"]')?._x_dataStack?.[0];
              if (alpine) {
                alpine.cgInit();
                alpine.setTableHeight();
              }
            }, 50);
          },
          onClose: () => enableBodyScroll()
        });
      }
    }))
    Alpine.data('LensColorGuide', () => ({
      e_LensColorGuide() {

       MicroModal.show('pop-lens-color-guide', {
  disableScroll: false,
  awaitCloseAnimation: false,
          disableScroll: true,
          onShow: () => {
            disableBodyScroll();
            const width = window.innerWidth;
            const height = window.innerHeight;
            console.log('width:', width, ' height ', height)
            if (width > 749 && height < 900) {
              const pop_lens_color_guide = document.querySelector('#pop-lens-color-guide .pop-lens-color-guide');
              setTimeout(() => {
                pop_lens_color_guide.scrollIntoView();
              }, 10)
            }
          },
          onClose: () => enableBodyScroll()
        });
      }
    }))
  })
})()